<template>
    <v-card>
        <v-card-title v-if="cardHasData">
            <v-spacer />
            <HelpModal
                v-if="helpText"
                :text="helpText"
                :title="helpTitle"
            />
        </v-card-title>
        <v-card-text v-if="cardHasData">
            <div
                v-for="(field, id) in fields"
                :key="field.id+id"
            >
                <Field
                    v-if="field.id"
                    :field-id="field.id"
                    :card-namespace="namespace"
                    :key="namespace+field.id+id"
                />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import Field from '@/views/Public/Field/Field';
import store from '@/store/store';
import HelpModal from '@/components/HelpModal';
export default {
    components: { HelpModal, Field },

    props: [
        'name',
        'cardHasData',
        'loaded',
        'namespace',
        'fields',
    ],

    computed: {
        helpTitle() {
            return store.state[this.namespace].helpTitle;
        },

        helpText() {
            return store.state[this.namespace].helpText;
        }
    },
};
</script>

